import React from "react";
import Costanti from "../../constantiX";
import axios from "axios";
import { Toast, Button, FileUpload, InputText, Dropdown } from "primereact";
import { Formik } from "formik";
import * as Yup from "yup";
import ReactGA from "react-ga4";
class Utente extends React.Component {
  constructor() {
    super();

    this.state = { xcarica: "sezione", dati: [], prodotto: {}, visible3: false, editMode: false };
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.ruoloid = JSON.parse(sessionStorage.getItem("ruoloid"));
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  validationSchema() {
    return Yup.object().shape({
      email: Yup.string()
        .required("Email obbligatoria")
        .typeError("Email obbligatoria")

        .email("Email non valida"),
      ruoloid: Yup.string().required("Ruolo obbligatorio").typeError("Ruolo obbligatorio"),
      cognome: Yup.string().required("Cognome obbligatorio").typeError("Cognome obbligatorio"),
      nome: Yup.string().required("Nome obbligatorio").typeError("Nome obbligatorio"),
    });
  }

  setEditMode(val) {
    this.setState({ editMode: val });
  }

  componentDidMount() {
    //alert(this.props.location.pathname);
    this.countries = [
      { name: "Admin", code: 3 },
      { name: "Utente", code: 4 },
    ];

    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    var id = this.props.match.params.id;
    var tipo = this.props.match.params.tipo;
    this.setState({ tipo: this.props.match.params.tipo, utenteid: this.props.match.params.id });

    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    if (tipo == "A") {
      this.setState({ editMode: true });
    } else {
      this.setState({ loading: true });
      var quer = id;
      axios
        .get(Costanti.UrlCallApi + "utente/" + quer, config)
        .then((res) => {
          this.setState({ dati: res.data, loading: false, editMode: tipo == "V" ? false : true });

          //alert(JSON.stringify(this.state.prodotti))
        })
        .catch((error) => {
          alert(error);
        });
    }
  }

  reset() {
    this.setEditMode(false);
    window.location.reload();
  }

  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });
    if (this.state.tipo == "U") {
      values.status = " ";
      axios
        .post(Costanti.UrlCallApi + "utente/salva/" + this.state.dati.id, values, config)
        .then(() => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "D") {
      values.status = "E";
      axios
        .post(Costanti.UrlCallApi + "utente/salva/" + this.state.dati.id, values, config)
        .then(() => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
          setTimeout(() => this.props.history.push("/listaUtenti"), 1000);
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      values.status = "A";
      values.aziendaid = this.utente.aziendaid;

      axios
        .post(Costanti.UrlCallApi + "utente/aggiungi", values, config)
        .then(() => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
          setTimeout(() => this.props.history.push("/listaUtenti"), 1000);
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
  }

  render() {
    return (
      <div className="surface-ground ">
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />
        <Formik
          initialValues={{
            id: this.state.dati.id,
            nome: this.state.dati.nome,
            cognome: this.state.dati.cognome,
            email: this.state.dati.email,
            ruoloid: this.state.dati.ruoloid,
            telefono: this.state.dati.telefono,
            password: "",
            aziendaid: this.utenteid,
          }}
          enableReinitialize
          validationSchema={this.validationSchema}
          onSubmit={(values) => {
            this.salva(values);
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <div className="text-600 font-medium text-600 text-xl mb-3">
                <Button onClick={() => this.props.history.push("/listaUtenti")} icon="pi pi-history" /> Dati
                Identificativi Utente{" "}
              </div>
              <div className="surface-card p-2  border-round">
                <div className="grid formgrid p-fluid">
                  <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="cognome" className="font-medium text-600">
                      Cognome
                    </label>
                    <InputText
                      name="cognome"
                      readOnly={!this.state.editMode}
                      value={values.cognome}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                    />
                    <div style={{ color: "red" }}>{errors.cognome && touched.cognome && errors.cognome}</div>
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="nome" className="font-medium text-600">
                      Nome
                    </label>
                    <InputText
                      name="nome"
                      readOnly={!this.state.editMode}
                      value={values.nome}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                    />
                    <div style={{ color: "red" }}>{errors.nome && touched.nome && errors.nome}</div>
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="email" className="font-medium text-600">
                      Email
                    </label>
                    <InputText
                      name="email"
                      readOnly={!this.state.editMode}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                    />
                    <div style={{ color: "red" }}>{errors.email && touched.email && errors.email}</div>
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    {this.utente.id == values.id ? (
                      <div>
                        <label htmlFor="password" className="font-medium text-600">
                          Password (valorizzare solo per modificare password)
                        </label>
                        <InputText
                          name="password"
                          readOnly={!this.state.editMode}
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="password"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                  <div className="field mb-4 col-12 md:col-6">
                    <label htmlFor="avatar2" className="font-medium text-900">
                      Avatar
                    </label>
                    <div className="flex align-items-center">
                      <img
                        src={
                          Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/utente/" + this.state.utenteid
                        }
                        className="w-full"
                        alt=""
                      />
                      <FileUpload
                        disabled={!this.state.editMode}
                        id="avatar2"
                        mode="basic"
                        name="avatar"
                        url={
                          Costanti.UrlCallApi +
                          "file/carica/" +
                          this.utente.aziendaid +
                          "/utente/" +
                          this.state.utenteid
                        }
                        onUpload={() => window.location.reload(false)}
                        onError={() => this.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")}
                        accept="image/*"
                        maxFileSize={10000000}
                        chooseOptions={{ className: "p-button-plain p-button-outlined" }}
                        chooseLabel="Cambia"
                      />
                    </div>
                  </div>

                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="country2" className="font-medium text-600">
                      Ruolo
                    </label>
                    <Dropdown
                      optionLabel="name"
                      options={this.countries}
                      optionValue="code"
                      value={values.ruoloid}
                      onChange={(e) => setFieldValue("ruoloid", e.value)}
                      placeholder="Seleziona Ruolo"
                    />
                    <div style={{ color: "red" }}>{errors.ruoloid && touched.ruoloid && errors.ruoloid}</div>
                  </div>
                  <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="country2" className="font-medium text-600">
                      Stato
                    </label>
                    {/*<InputText id="email2" readonly type="text" className="customer-badge status-approvato" value="Approvato"/>*/}
                  </div>

                  <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
                  <div className="col-12">
                    {this.state.tipo == "A" ? <Button label="Aggiungi" className="w-auto mt-3" /> : ""}
                    {this.state.tipo == "U" ? <Button label="Salva" className="w-auto mt-3" /> : ""}
                    {this.state.tipo == "D" ? <Button label="Elimina" className="w-auto mt-3" /> : ""}
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    );
  }
}

export default Utente;
